// Vehicle GraphQL queries and mutations for 8base
import { gql } from '@apollo/client';

export const VEHICLES_LIST = gql`
  query VehiclesList {
    vehiclesList {
      items {
        id
        vIN
        unitNumber
        make
        model
        year
        status
        licensePlate
        purchaseDate
        businessUnit {
          id
          name
        }
        insurancePolicy {
          id
          policyNumber
          provider
        }
        maintenanceRecords {
          items {
            id
            category
            scheduledDate
            performedDate
            cost
            description
          }
        }
        assignments {
          items {
            id
            startDate
            endDate
            employee {
                          firstName
            id
            lastName
            }
          }
        }
        workOrders {
          items {
            id
            title
            category
            status
            dateOpened
            estimatedCompletionDate
            assignedTo {
              id
              firstName
              lastName
            }
          }
        }
        inspections {
          items {
            id
            component
            startDate
            endDate
            notes
            employee {
                          firstName
            id
            lastName
            }
          }
        }
        warrantyRecords {
          items {
            id
            component
            scheduledDate
            startDate
            endDate
            company_name
            warranty_details
            warranty_type
          }
        }
        registrations {
          items {
            id
            registrationNumber
            annualDate
            expiryDate
          }
        }
      }
    }
  }
`;

export const VEHICLES_LIST_FILTERED = gql`
  query VehiclesListFiltered($filter: VehicleFilter, $first: Int, $skip: Int) {
    vehiclesList(filter: $filter, first: $first, skip: $skip) {
      items {
        id
        vIN
        unitNumber
        make
        model
        year
        status
        licensePlate
        purchaseDate
        businessUnit {
          id
          name
        }
        insurancePolicy {
          id
          policyNumber
          provider
        }
        maintenanceRecords {
          items {
            id
            category
            scheduledDate
            performedDate
            cost
            description
          }
        }
        assignments {
          items {
            id
            startDate
            endDate
            employee {
                          firstName
            id
            lastName
            }
          }
        }
        workOrders {
          items {
            id
            title
            category
            status
            dateOpened
            estimatedCompletionDate
            assignedTo {
              id
              firstName
              lastName
            }
          }
        }
        inspections {
          items {
            id
            component
            startDate
            endDate
            notes
            employee {
                          firstName
            id
            lastName
            }
          }
        }
        warrantyRecords {
          items {
            id
            component
            scheduledDate
            startDate
            endDate
            company_name
            warranty_details
            warranty_type
          }
        }
        registrations {
          items {
            id
            registrationNumber
            annualDate
            expiryDate
          }
        }
      }
      count
    }
  }
`;

export const VEHICLE_GET = gql`
  query VehicleGet($id: ID!) {
    vehicle(id: $id) {
      id
      make
      model
      year
      vin
      licensePlate
      status
      permittedDrivers {
        items {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const VEHICLE_GET_LIST_FILTER = gql`
  query VehicleGet($id: ID!) {
    vehiclesList(filter: { id: { equals: $id } }) {
      items {
        id
        vIN
        unitNumber
        make
        model
        year
        status
        licensePlate
        purchaseDate
        businessUnit {
          id
          name
        }
        insurancePolicy {
          id
          policyNumber
          provider
        }
        maintenanceRecords {
          items {
            id
            category
            scheduledDate
            performedDate
            cost
            description
          }
        }
        assignments {
          items {
            id
            startDate
            endDate
            employee {
              firstName
              id
              lastName
            }
          }
        }
        workOrders {
          items {
            id
            title
            category
            status
            dateOpened
            estimatedCompletionDate
            assignedTo {
              id
              firstName
              lastName
            }
          }
        }
        inspections {
          items {
            id
            component
            startDate
            endDate
            notes
            employee {
              firstName
              id
              lastName
            }
          }
        }
        warrantyRecords {
          items {
            id
            component
            scheduledDate
            startDate
            endDate
            company_name
            warranty_details
            warranty_type
          }
        }
        registrations {
          items {
            id
            registrationNumber
            annualDate
            expiryDate
          }
        }
      }
    }
  }
`;

export const VEHICLE_CREATE = gql`
  mutation VehicleCreate($data: VehicleCreateInput!) {
    vehicleCreate(data: $data) {
      id
      vIN
      unitNumber
      make
      model
      year
      status
      licensePlate
      purchaseDate
      businessUnit {
        id
        name
      }
    }
  }
`;

export const VEHICLE_UPDATE = gql`
  mutation VehicleUpdate($filter: VehicleKeyFilter!, $data: VehicleUpdateInput!) {
    vehicleUpdate(filter: $filter, data: $data) {
      id
      vIN
      unitNumber
      make
      model
      year
      status
      licensePlate
      purchaseDate
      businessUnit {
        id
        name
      }
    }
  }
`;

export const VEHICLE_DELETE = gql`
  mutation VehicleDelete($id: ID!) {
    vehicleDelete(id: $id) {
      success
    }
  }
`; 

export const VEHICLE_WARRANTY_CREATE = gql`
  mutation warrantyRecordCreate($data: WarrantyRecordCreateInput!) {
    warrantyRecordCreate(data: $data) {
      id
    }
  }
`;

export const VEHICLE_WARRANTY_UPDATE = gql`
  mutation warrantyRecordUpdate($filter: WarrantyRecordKeyFilter!, $data: WarrantyRecordUpdateInput!) {
    warrantyRecordUpdate(filter: $filter, data: $data) {
      id
    }
  }
`;